'use client';

import React from 'react';

const STUDIOS = [
  { name: 'BBC', abbr: true },
  { name: 'Channel 4', abbr: false },
  { name: 'Netflix', abbr: false },
  { name: 'Framestore', abbr: false },
  { name: 'MPC', abbr: true },
  { name: 'Sky Studios', abbr: false },
  { name: 'ITV Studios', abbr: false },
  { name: 'Technicolor', abbr: false },
  { name: 'Double Negative', abbr: false },
  { name: 'Warner Bros.', abbr: false },
];

export default function LogoBar() {
  // Duplicate for seamless loop
  const doubled = [...STUDIOS, ...STUDIOS];

  return (
    <section
      className="relative overflow-hidden py-10"
      style={{
        background: '#0B1A2E',
        borderTop: '1px solid rgba(244,246,248,0.06)',
        borderBottom: '1px solid rgba(244,246,248,0.06)',
      }}
    >
      {/* Label */}
      <div className="text-center mb-6">
        <p
          className="text-xs font-semibold tracking-widest uppercase"
          style={{ color: 'rgba(244,246,248,0.35)' }}
        >
          Where their editors trained.
        </p>
      </div>

      {/* Fade edges */}
      <div
        className="absolute top-0 left-0 w-24 h-full pointer-events-none z-10"
        style={{ background: 'linear-gradient(to right, #0B1A2E, transparent)' }}
      />
      <div
        className="absolute top-0 right-0 w-24 h-full pointer-events-none z-10"
        style={{ background: 'linear-gradient(to left, #0B1A2E, transparent)' }}
      />

      {/* Marquee */}
      <div className="overflow-hidden">
        <div className="marquee-track">
          {doubled.map((studio, i) => (
            <div
              key={`${studio.name}-${i}`}
              className="flex items-center gap-3 mx-10 cursor-default select-none"
              style={{ whiteSpace: 'nowrap' }}
            >
              {/* Logo pill */}
              <div
                className="inline-flex items-center px-5 py-2.5 rounded-lg transition-colors duration-300"
                style={{
                  background: 'rgba(244,246,248,0.04)',
                  border: '1px solid rgba(244,246,248,0.08)',
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLElement).style.background = 'rgba(244,246,248,0.08)';
                  (e.currentTarget as HTMLElement).style.borderColor = 'rgba(244,246,248,0.15)';
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLElement).style.background = 'rgba(244,246,248,0.04)';
                  (e.currentTarget as HTMLElement).style.borderColor = 'rgba(244,246,248,0.08)';
                }}
              >
                <span
                  className="font-display font-light tracking-tight text-sm"
                  style={{ color: 'rgba(244,246,248,0.55)' }}
                >
                  {studio.name}
                </span>
              </div>
              {/* Separator dot */}
              <div
                className="w-1 h-1 rounded-full"
                style={{ background: 'rgba(244,246,248,0.12)' }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}